import { createContext } from "react";
import { CsrStrategy } from "src/api/client-api/csrStrategy/useGetAllStrategy";

export type StrategyInitialValues = {
    strategy: CsrStrategy | undefined;
};
export const StrategyContext = createContext<StrategyInitialValues | null>(null);
